import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { Upload } from 'components';
import { content } from './content';
import { saveAs } from 'file-saver';
import { updateBusinessPlanExpense } from '../../../../../../../store/forms/actions';
import docInvestmentExpenses from 'assets/documents/Δαπάνες Επένδυσης.xlsm';

const DocsInvestor = ({ group }) => {
  const dispatch = useDispatch();
  const companyLegalType = useSelector(
    state => state.forms.carrier.companyLegalType
  );
  const atomiki = (companyLegalType || '').toUpperCase() === 'SP';
  const [formFile, setFormFile] = useState();

  const handleFile = file => {
    if (file) {
      const form = new FormData();
      form.append('file', file);
      setFormFile(form);
      dispatch(updateBusinessPlanExpense(true));
    } else {
      setFormFile(null);
      dispatch(updateBusinessPlanExpense(false));
    }
  };

  // Corrected download handler that fetches file as Blob first:
  const handleDownload = () => {
    fetch(docInvestmentExpenses)
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to download file');
        }
        return response.blob();
      })
      .then(blob => {
        saveAs(blob, 'Δαπάνες Επένδυσης.xlsm');
      })
      .catch(error => {
        console.error('Download error:', error);
      });
  };

  return (
    <div className="mt-1 pb-5">
      <p className="mt-6 mr-0 color-purple-3 text-bold font-size-24">
        Δικαιολογητικά
      </p>

      <Upload
        item={{
          label: (
            <span style={{ display: 'flex', flexDirection: 'column' }}>
              <span style={{ display: 'flex', alignItems: 'flex-start' }}>
                <b>
                  Συμπληρωμένο σε Ηλεκτρονική Μορφή Excel "Δαπάνες Επένδυσης"{' '}
                </b>
                <span style={{ marginLeft: '3px' }} className="color-red">
                  {' '}
                  *
                </span>
              </span>
              <span style={{ fontWeight: 'normal', fontSize: '11px' }}>
                (Κατεβάστε το υπόδειγμα{' '}
                <a
                  style={{ textDecoration: 'underline', cursor: 'pointer' }}
                  onClick={handleDownload}
                  role="button"
                  tabIndex={0}
                  onKeyPress={e => {
                    if (e.key === 'Enter' || e.key === ' ') handleDownload();
                  }}
                >
                  εδώ
                </a>
                )
              </span>
            </span>
          ),
          fileCode: 'investmentExpenditures',
          id: 'investmentExpenditures',
          fileLimit: 10,
          fileAccepts:
            '.xls, .xlsm, .doc, PNG, application/vnd.ms-excel.sheet.macroenabled.12, JPG or GIF',
          // required: true,
        }}
        group={'documents'}
        subFileCode="investmentExpenditures"
        mode="investmentExpenditures"
        handleFile={handleFile}
        disabled
      />

      {content(atomiki).map((item, index) => (
        <Upload
          item={item}
          subFileCode={item.fileCode}
          key={index}
          group={'documents'}
        />
      ))}
    </div>
  );
};

DocsInvestor.propTypes = {
  group: PropTypes.string.isRequired,
};

export default DocsInvestor;
